module.exports = __webpack_public_path__ + "assets/webcam.aaaf2567.svg";